
/**
 * 全局自定义指令
 * 校内认证开关控制
 */
Vue.directive('certification_show', function (el, binding) {
  // console.log('自定义指令',el.dataset.coursetype,binding.value)
  if ((el.dataset.coursetype == '1' && binding.value.mooc) || (el.dataset.coursetype == 2 && binding.value.spoc)) {
      //显示
      el.style.display = 'block'
  } else {
      //不显示
      el.style.display = 'none'
  }
})